export default __webpack_public_path__ + "static/media/viber_image_2022-06-06_11-16-10-625.f0587477.jpg";